import * as React from 'react';
import { createContainer } from 'unstated-next';

export interface ReferenceInterface {
  visible: boolean;
  search: string;
  results: Array<any>;
  cursor: number;
  setCursor: (value: number) => void;
  display: (search: string, results: Array<any>) => void;
  hide: () => void;
}

function usePaletteState() {
  const [visible, setVisible] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [cursor, setCursor] = React.useState(0);

  const display = (search: string, results: any = []) => {
    setVisible(true);
    setResults(results);
    setCursor(0);
    setSearch(search);
  };

  const hide = () => {
    setVisible(false);
    setResults([]);
    setSearch('');
  };

  return {
    visible,
    search,
    results,
    cursor,
    setCursor,
    display,
    hide
  };
}

export const Reference = createContainer(usePaletteState);
